import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "../setup";
import Noti from "../../../view/components/general/noti";
import {ROUTES} from "../../../constants";
import {PatientProgramService} from "../../../services/requests/ehr/patientProgram";

const useGetPatientPrograms = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getPatientPrograms", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return PatientProgramService.getPatientProgramsList(params);
    },
    enabled: modalName ?? true
  });
}

const useGetPatientProgram = () => {
  return useMutation({
    mutationFn: PatientProgramService.getPatientProgram,
  })
}

const useAddPatientProgram = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: PatientProgramService.addPatientProgram,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getPatientPrograms"] })
          onSuccess();
        }
      })
    },
  })
}

const useDeletePatientProgram = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: PatientProgramService.deletePatientProgram,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          console.log(data)
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getPatientPrograms"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetPatientPrograms,
  useGetPatientProgram,
  useAddPatientProgram,
  useDeletePatientProgram
}
